import { render, staticRenderFns } from "./RabbeyTablesTabs.vue?vue&type=template&id=6192d0e4&"
import script from "./RabbeyTablesTabs.vue?vue&type=script&lang=js&"
export * from "./RabbeyTablesTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports